export const environment = {
    apiBaseUrl: 'https://summit-login-backend.fozzyfrommuppetsstudio.workers.dev/api'
};